<template>
  <div class="main" >
    <div class="index-container">
      <div class="index-bg" >
        <div class="choose-container flex-items flex-center">
          <div class="tb-items left">
            <div class="item">
              <div class="title">单独投标</div>
              <div><span class="line"></span></div>
              <div class="sub-title">一家企业或个人对某一采购项进行投标</div>
              <div>
                <div class="tb-btn" @click="navTo('/toubiao?type=1')">去投标</div>
              </div>
            </div>

            <img src="../assets/images/index/tb1.png" alt="">
          </div>
          <div class="tb-items right">
            <div class="item">
              <div class="title">联合体投标</div>
              <div><span class="line"></span></div>
              <div class="sub-title">企业组成联合体，以联合体的名义对某一采购项目进行投标</div>
              <div>
                <div class="tb-btn"  @click="navTo('/toubiao?type=2')">去投标</div>
              </div>
            </div>

            <img src="../assets/images/index/tb1.png" alt="">
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      typeId:'',
      startDate:'',
      endDate:'',
      keyWord:'',
      total:0,
      page:1,
      pageSize:10,
      itemList:[
      ],
      productList:[
      ],
      provinceList:[],
      cityList:[],
      areaList:[],
      itemId:'',
      provinceId:'',
      cityId:'',
      areaId:'',
      hasData:false,

    }
  },
  computed:{
    baseInfo(){
      return this.$store.state.baseInfo
    }
  },
  created(){
    // this.getConfig()

  },
  mounted(){

    let token = this.$store.state.token;
    if (!token){
       this.$router.push('/login')
      //localStorage.clear()
    }else{
      // let userInfo=localStorage.getItem("userInfo")
      // this.userInfo=JSON.parse(userInfo)
      // this.getList()
    }
    //
    // this.getList();
    // this.getprovince()
    // this.getCategory()
  },
  methods:{
    search(){
      this.page = 1;
      let params={
        keyword:this.keyWord,
        category_id:this.itemId,
        province_id:this.provinceId,
        city_id:this.cityId,
        // district_id:this.areaId,
        start_date:this.startDate,
        end_date:this.endDate,
        limit:this.pageSize,
        page:this.page
      };
      this.getList(params)
    },
    search2(){
      this.page = 1;
      let params={
        category_id:this.itemId,
        province_id:this.provinceId,
        city_id:this.cityId,
        // district_id:this.areaId,
        start_date:this.startDate,
        end_date:this.endDate,
        limit:this.pageSize,
        page:this.page
      };
      this.getList(params)
    },
    getConfig(){
      this.$get('/api/config',{}).then(res=>{
        this.$store.commit("setConfig", res.data);
      })
    },
    showPop(url){
      this.$dialog.alert({
        message:url
      })
    },
    showContent(content){
      this.$dialog.alert({
        message:content
      })
    },
    chooseItem(id){
      if (id ==this.itemId){

        this.itemId=''
      }else{
        this.itemId=id
      }
    },
    getList(data){
      let params={
        limit:this.pageSize,page:this.page
      }
      if (data){
        params = data
      }
      this.$get('/api/project',params).then(res=>{
        this.total = res.data.total;
        this.productList=res.data.list
        this.hasData=true
      }).catch(()=>{
        this.hasData=false
      })
    },
    getCategory(){
      this.$get('/api/category').then(res=>{
        this.itemList=res.data
      })
    },
    chooseProvince(e){
      this.getCity(e)


    },
    chooseCity(e){
      this.getArea(e)
    },
    getprovince(){
      this.$get('/api/address').then(res=>{
        this.provinceList=res.data
      })
    },
    getCity(id){
      this.$get('/api/address',{parent_id:id}).then(res=>{
        this.cityList=res.data
        this.search2()
      })


    },
    getArea(id){
      this.$get('/api/address',{parent_id:id}).then(res=>{
        this.areaList=res.data
        this.search2()
      })

    },
    reset(){
      this.areaId='';
      this.provinceId='';
      this.cityId='';
      this.itemId='';
      this.startDate='';
      this.endDate='';
      this.keyWord='';
      this.page = 1;
      this.getList()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getList()
    },
    confirmUrl(id){
      // this.$api.setUrl({id:id}).then(res=>{
      //   if (res.success){
      //     this.$toast.success('操作成功')
      //     this.getList()
      //   }
      // })
      this.$router.push('/Sign?id='+id)
    },
    goDetails(id){
      this.$router.push('/projectDetails?id='+id)
    },
    logout(){
      this.$dialog.confirm({
        title:'提示',
        message:'您确定要退出登陆吗？'
      }).then(()=>{
        localStorage.setItem('token','')
        this.$router.push('/login')
      }).catch(()=>{

      })

    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.main{
  .index-container{
    .index-bg{
      display: flex;
     height: 667px;
      width: 100%;
      background-image: url('../assets/images/index/index-bg.png');
      background-size:100% 100% ;
      position: relative;
      .choose-container{
        margin: auto;
        .tb-items{
          width: 300px;
          height: 285px;

          box-sizing: border-box;
          position: relative;
          .item{
            padding: 30px 76px 0 30px;
          }
          .title{
            font-weight: 500;
            font-size: 30px;
            color: #333333;
            line-height: 24px;
          }
          .line{
            display: inline-block;
            width: 32px;
            height: 2px;
            margin: 15px 0;
          }
          .sub-title{
            font-weight: 400;
            font-size: 14px;
            line-height: 24px;
            margin-bottom: 9px;
          }
          .tb-btn{
            width: 70px;
            line-height: 28px;
            text-align: center;
            color: #fff;
            cursor: pointer;
            border-radius: 50px;
          }
          img{
            position: absolute;
            width: 120px;
            bottom: 0;
            right: 0;
          }
        }
        .left{
          background: linear-gradient( 144deg, #DCE7FF 0%, #B7CDFF 100%, #B5CBFF 100%);
          box-shadow: 0px 4px 10px 0px rgba(56,126,255,0.27);
          border-radius: 20px 20px 20px 20px;
          border: 2px solid #1567F8;
          margin-right: 87px;
          .line{
            background: #1668F8;
          }
          .sub-title{
            color: #1668F8;
          }
          .tb-btn{
            background: #1668F8;
          }

        }
        .right{
          background: linear-gradient( 142deg, #D6F1FC 0%, #CCECF9 99%);
          border-radius: 20px 20px 20px 20px;
          border: 2px solid #FFFFFF;
          .line{
            background: #2BAFCE;
          }
          .sub-title{
            color: #2BAFCE;
          }
          .tb-btn{
            background: #2BAFCE;
          }
        }
      }
    }
  }
}
</style>
